var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"py-0",attrs:{"cols":"12"}},[_c('v-tabs-items',{model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},_vm._l((_vm.items),function(item){return _c('v-tab-item',{key:item.name},[_c(item.name,{tag:"component"}),_vm._v(" "),_c('dms-roles-form-actions')],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }